<template>
  <div class="cstm-history-note">
    <p class="hstr-store">{{ history.store }}</p>
    <p class="hstr-time">{{ history.time }}</p>
    <p class="hstr-number">{{ history.persons }}名</p>
    <p class="hstr-table">{{ historyTable }}</p>
    <p class="hstr-order" v-for="(course, index) in history.course" :key="index">{{ course }}</p>
    <p v-if="isMediaSpecified" class="hstr-info"><span>予約媒体</span><span>：</span>{{ history.medium }}</p>
    <p v-if="isSettlementSpecified" class="hstr-info"><span>決済情報</span><span>：</span>{{ history.settlement }}</p>
    <p v-if="history.remarks" class="hstr-info"><span>備考</span><span>：</span>{{ history.remarks }}</p>
    <div class="additional-info-btn">
      <Button small v-if="history.ordersExistence" @click.prevent="showEatInfoModal(history.rsvId)">喫食情報</Button>
      <Button small v-if="showReserveDetailButton" @click.prevent="toReservationHistoryDetail">予約詳細</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getSettlementCodeByStr } from '@/resources/reservation/settlementMap'
import Button from '@/components/atoms/Button'

/**
 * 来店履歴
 */
export default {
  name: 'VisitHistory',
  components: {
    Button,
  },
  props: {
    history: Object,
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      currentStore: state => state.stores.current.store,
    }),
    ...mapGetters({
      mediaIdsByName: 'medias/idsByName',
    }),
    historyTable() {
      return this.history.table.length ? this.history.table.join('、') : '未指定'
    },
    isMediaSpecified() {
      return !!this.mediaIdsByName[this.history.medium]
    },
    isSettlementSpecified() {
      return !!getSettlementCodeByStr(this.history.settlement)
    },
    showReserveDetailButton() {
      return this.history.storeId === this.currentStore.id
    },
  },
  methods: {
    showEatInfoModal(rsvId) {
      this.$emit('showEatInfoModal', rsvId)
    },
    toReservationHistoryDetail() {
      this.isSP
        ? this.$router.push({ name: 'ReserveDetail', params: { id: this.history.rsvId } })
        : location.assign(`/reservation/history/detail?reservation_id=${this.history.rsvId}`)
    },
  },
}
</script>

<style lang="postcss" scoped>
.cstm-history-note {
  border-left: 1px solid var(--border-color);
  font-size: 15px;
  grid-column: 1 / -1;
  margin-left: 22px;
  padding-left: 15px;

  p {
    margin-top: 4px;
  }

  .hstr-store {
    font-weight: bold;
    margin-top: 0;
  }

  .hstr-time {
    background: url(/assets/img/icons/history_time.png) no-repeat left center;
    background-size: 16px 16px;
    padding-left: 24px;
  }

  .hstr-number {
    background: url(/assets/img/icons/history_number.png) no-repeat left center;
    background-size: 16px 16px;
    padding-left: 24px;
  }

  .hstr-table {
    background: url(/assets/img/icons/history_table.png) no-repeat left center;
    background-size: 16px 16px;
    padding-left: 24px;
  }

  .hstr-order {
    background: url(/assets/img/icons/history_order.png) no-repeat left 3px;
    background-size: 16px 16px;
    padding-left: 24px;
  }

  .additional-info-btn {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;

    >>> button {
      margin-right: 5px;
    }
  }
}

.hstr-info {
  display: grid;
  grid-template-columns: 4em 1em 1fr;
  white-space: pre-line;
}
</style>
